import { apiRequest } from '../apiHelper';
import ROUTES from './index.constant';

export type SortBy =
    | 'roleName'
    | 'description'
    | 'type'
    | 'usersCount'
    | 'updatedDate';

export interface TenantRolePayload {
    tenantId: number;
    roleName: string;
    description?: string;
    permissionIds?: number[];
}

export interface PrimaryRoleOverridePayload {
  tenantId: number;
  systemRoleTemplateId: number;
  description?: string;
  permissionIds: number[];
}

export type SortOrder = 'ASC' | 'DESC';

export const getTenantRoles = async (
    tenantId: string | number,
    query?: {
        dropdown?: boolean;
        allTenants?: boolean;
        role?: string;
        sortBy?: SortBy | string;
        sortOrder?: SortOrder;
        page?: number;
        limit?: number;
    }
) => {
    const searchParams = new URLSearchParams();

    if (query?.dropdown !== undefined) searchParams.set('dropdown', String(query.dropdown));
    if (query?.allTenants !== undefined) searchParams.set('allTenants', String(query.allTenants));
    if (query?.role) searchParams.set('roleName', query.role);
    if (query?.sortBy) searchParams.set('sortBy',query.sortBy);
    if (query?.sortOrder) searchParams.set('sortOrder', query.sortOrder);
    if (query?.page !== undefined) searchParams.set('page', String(query.page));
    if (query?.limit !== undefined) searchParams.set('limit', String(query.limit));

    const queryString = searchParams.toString();
    const url = `${ROUTES.ALL_ROLES}/${tenantId}${queryString ? `?${queryString}` : ''}`;

    return apiRequest(url, {
        method: 'GET',
    });
};

export const getTenantRolePermissionList = async (
    tenantId: number | string
) => {
    return apiRequest(`${ROUTES.ALL_ROLES}/permissionList/${tenantId}`, {
        method: 'GET',
    });
};

export const createTenantRole = async (
    payload: TenantRolePayload
) => {
    return apiRequest(ROUTES.ALL_ROLES, {
        method: 'POST',
        body: payload,
    });
};

export const updateTenantRole = async (
    roleId: number,
    payload: TenantRolePayload
) => {
    return apiRequest(`${ROUTES.ALL_ROLES}/${roleId}`, {
        method: 'PUT',
        body: payload,
    });
};

export const createPrimaryRoleOverride = async (
    payload: PrimaryRoleOverridePayload
) => {
    return apiRequest(ROUTES.PRIMARY_ROLE_OVERRIDE, {
        method: 'POST',
        body: payload,
    });
};

export const resetPrimaryRoleOverridePermissions = async (
    tenantRoleId: number
) => {
    return apiRequest(
        `${ROUTES.PRIMARY_ROLE_OVERRIDE}/${tenantRoleId}/resetPermissions`,
        {
            method: 'PUT',
        }
    );
};

export const getRoleInfo = async (
    tenantId: number,
    roleCode: string,
) => {
    return apiRequest(
        `${ROUTES.ALL_ROLES}/role-info/${tenantId}/${roleCode}`,
        {
            method: 'GET',
        },
    );
};


export const deleteTenantCustomRole = async (roleId: number) => {
	return apiRequest(`${ROUTES.ALL_ROLES}/${roleId}`, {
		method: 'DELETE'
	});
};